import styled from 'styled-components'

const Button = styled.button<{ secondary?: boolean }>`
  font-family: ${({ theme }) => theme.fonts.regular};
  font-size: ${({ theme }) => theme.fontSize.s12};
  color: ${({ secondary }) => (secondary ? 'white' : 'black')};
  padding-inline: 10px;
  padding-block: 0;
  background-color: ${({ theme, secondary }) =>
    secondary ? 'transparent' : theme.colors.white};
  border-radius: 3px;
  height: 20px;
  border: ${({ secondary }) => (secondary ? '1px solid #6D7284' : 'none')};

  :hover {
    color: ${({ secondary, theme }) =>
      secondary ? '' : theme.colors.gray1};
    border-color: ${({ secondary, theme }) =>
      secondary ? 'none' : theme.colors.gray1};
  }
`

export default Button
